var r={};export{r as __exports};
//# sourceMappingURL=object-get-own-property-descriptor.js.map
